import * as icons from 'core/icons';

const ventas = {
    id: 'ventas',
    title: 'Ventas',
    type: 'group',
    collapse: false,
    visible: true,
    children: [
        {
            id: 'presupuestos',
            title: 'Presupuestos',
            type: 'item',
            visible: true,
            url: '/gestion/tramites/resoluciones',
            icon: icons.PresupuestosIcon,
            breadcrumbs: false
        },
        {
            id: 'albaranes',
            title: 'Albaranes',
            type: 'item',
            visible: true,
            url: '/gestion/tramites/resoluciones',
            icon: icons.AlbaranesIcon,
            breadcrumbs: false
        },
        {
            id: 'facturas',
            title: 'Facturas',
            type: 'item',
            visible: true,
            url: '/gestion/tramites/resoluciones',
            icon: icons.FacturasIcon,
            breadcrumbs: false
        }
    ]
};

export default ventas;
